import TextField from 'forms/shared/fields/text'
import React from 'react'
import { Field } from 'redux-form'
import TextArea from 'forms/shared/fields/text-area'

const inputErrorClass = `border-red-500 leading-tight`

const inputClass =
  'block placeholder-secondary-greyborder border bg-white border-grey-light w-full px-4 py-3 rounded focus:border-primary-orange'
const Fields = () => {
  return (
    <>
      <Field
        type={'text'}
        name={'firstName'}
        placeholder={'First Name'}
        groupClassName="mb-4"
        inputClassName={inputClass}
        inputErrorClassName={inputErrorClass}
        errorClassName="text-red-500 text-xs italic"
        component={TextField}
      />
      <Field
        type={'text'}
        name={'lastName'}
        placeholder={'Last Name'}
        groupClassName="mb-4"
        inputClassName={inputClass}
        inputErrorClassName={inputErrorClass}
        errorClassName="text-red-500 text-xs italic"
        component={TextField}
      />
      <Field
        type={'email'}
        name={'email'}
        placeholder={'Email'}
        groupClassName="mb-4"
        inputClassName={inputClass}
        inputErrorClassName={inputErrorClass}
        errorClassName="text-red-500 text-xs italic"
        component={TextField}
      />
      <Field
        type={'text'}
        name={'phone'}
        placeholder={'Mobile Number'}
        groupClassName="mb-4"
        inputClassName={inputClass}
        inputErrorClassName={inputErrorClass}
        errorClassName="text-red-500 text-xs italic"
        component={TextField}
      />
      <Field
        type={'text'}
        name={'notes'}
        placeholder="Note"
        groupClassName="mb-4"
        rows={4}
        inputClassName={inputClass}
        inputErrorClassName={inputErrorClass}
        errorClassName="text-red-500 text-xs italic"
        component={TextArea}
      />
    </>
  )
}

export default Fields
